import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="pricing-requests--calculator"
export default class extends Controller {
  static targets = ['grandTotal']
  static values = {
    partialWarning: String,
    currencyCode: String,
    locale: String,
  }

  connect() {
    this.recalculate()
  }

  recalculate() {
    let grandTotal = 0
    const groupTotals = {}
    const categoryTotals = {}

    this.element.querySelectorAll('.pricing-rate-input').forEach(input => {
      const rate = parseFloat(input.value) || 0
      const qty = parseFloat(input.dataset.quantity) || 0
      const total = rate * qty
      const { lineId, groupId, categoryId } = input.dataset

      const lineCell = this.element.querySelector(`#total_${lineId}`)
      if (lineCell) this.#writeCell(lineCell, total, rate > 0)

      if (groupId) groupTotals[groupId] = (groupTotals[groupId] || 0) + total
      if (categoryId) categoryTotals[categoryId] = (categoryTotals[categoryId] || 0) + total

      grandTotal += total
    })

    Object.entries(groupTotals).forEach(([id, v]) => {
      const cell = this.element.querySelector(`#total_${id}`)
      if (cell) this.#writeCell(cell, v, v > 0)
    })

    Object.entries(categoryTotals).forEach(([id, v]) => {
      const cell = this.element.querySelector(`#total_${id}`)
      if (cell) this.#writeCell(cell, v, v > 0)
    })

    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.#formatAmount(grandTotal)
    }
  }

  handleSubmit(event) {
    const btn = document.activeElement
    if (!btn || btn.value !== 'submit') return

    const blanks = Array.from(this.element.querySelectorAll('.pricing-rate-input'))
      .filter(i => i.value.trim() === '').length

    if (blanks === 0) return

    event.preventDefault()
    const message = this.partialWarningValue.replace('%{count}', blanks)
    if (confirm(message)) {
      const hidden = document.createElement('input')
      hidden.type = 'hidden'
      hidden.name = 'submission_mode'
      hidden.value = 'submit'
      this.element.appendChild(hidden)
      this.element.submit()
    }
  }

  #writeCell(cell, value, active) {
    cell.textContent = this.#formatAmount(value)
    cell.classList.toggle('text-dark', active)
    cell.classList.toggle('text-muted', !active)
  }

  #formatAmount(value) {
    if (value <= 0) return '—'
    return new Intl.NumberFormat(this.localeValue, {
      style: 'currency',
      currency: this.currencyCodeValue,
    }).format(value)
  }
}
